// extracted by mini-css-extract-plugin
export var container = "_2i-0";
export var disabled = "_2i-3";
export var enabled = "_2i-2";
export var statusLight = "_2i-1";